export function mapCardBrandToIugu(cardValidatorType) {
  if (cardValidatorType == null || String(cardValidatorType).trim() === '') {
    return undefined;
  }

  const map = {
    visa: 'VISA',
    mastercard: 'MASTERCARD',
    'american-express': 'AMEX',
    elo: 'ELO',
    'diners-club': 'DINERS',
    discover: 'DISCOVER',
    jcb: 'JCB',
    unionpay: 'UNIONPAY',
    maestro: 'MAESTRO',
    hipercard: 'HIPERCARD',
    hiper: 'HIPER',
  };

  const key = String(cardValidatorType).trim().toLowerCase();
  if (map[key]) {
    return map[key];
  }

  return String(cardValidatorType).trim().toUpperCase();
}
